import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  CORE_I18N_FOLDER,
  CORE_PAGE_MODULE,
  CorePageModule,
  CorePageModuleIDs
} from '@bepatient/core';
import { TakeMeasureStoreModule } from '@bepatient/take-measure-store';
import { IonicModule } from '@ionic/angular';

const pageModule: CorePageModule = {
  ID: CorePageModuleIDs.TAKE_MEASURE,
  i18nLabel: 'MODULES.TAKE_MEASURE',
  icon: 'pulse',
  leftMenuAvailableForPages: [0, 1, 2, 3],
  routes: [
    {
      path: 'take-measure-list',
      loadChildren: () =>
        import('./pages/list/list.module').then(
          module => module.TakeMeasureListPageModule
        )
    },
    {
      path: 'take-measure-manual',
      loadChildren: () =>
        import('./pages/manual/manual.module').then(
          module => module.TakeMeasureManualPageModule
        )
    }
  ]
};

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    TakeMeasureStoreModule,
    RouterModule.forChild(pageModule.routes)
  ],
  providers: [
    { provide: CORE_PAGE_MODULE, useValue: pageModule, multi: true },
    { provide: CORE_I18N_FOLDER, useValue: './take-measure/i18n/', multi: true }
  ]
})
export class TakeMeasureModule {}
